import { render, staticRenderFns } from "./ChallengeHeaderDesk.vue?vue&type=template&id=6eb60fea"
import script from "./ChallengeHeaderDesk.vue?vue&type=script&lang=js"
export * from "./ChallengeHeaderDesk.vue?vue&type=script&lang=js"
import style0 from "./ChallengeHeaderDesk.vue?vue&type=style&index=0&id=6eb60fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports